export default "__VITE_ASSET__D$L1S9SA__"